import React, { useMemo } from "react";
import { isNumber } from "lodash";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { ConstantFormat } from "../../../../../../../utils/DateFns";
import { CellContentRoot } from "..";

const ExecutorArrivalDateCellContent: React.FC<
	ExecutorArrivalDateCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const lastReceivedOrder = useMemo(
		() => item?.additionalFields?.transfer?.lastReceivedOrder,
		[item?.additionalFields?.transfer?.lastReceivedOrder],
	);

	const transferExecutor = useMemo(
		() => lastReceivedOrder?.executorToOrder?.[0],
		[lastReceivedOrder?.executorToOrder],
	);
	const mainExecutor = useMemo(
		() => item.executorToOrder?.[0],
		[item.executorToOrder],
	);

	const mainArrivalTime = useMemo(
		() => mainExecutor?.additionalFields?.arrivalTime,
		[mainExecutor?.additionalFields?.arrivalTime],
	);

	const transferArrivalTime = useMemo(
		() => transferExecutor?.additionalFields?.arrivalTime,
		[transferExecutor?.additionalFields?.arrivalTime],
	);

	const arrivalTime = useMemo(
		() => mainArrivalTime || transferArrivalTime,
		[mainArrivalTime, transferArrivalTime],
	);

	const content = useMemo(() => {
		if (!isNumber(arrivalTime) || !dateFns) return "";

		return dateFns.formatTime(arrivalTime, {
			formatTime: ConstantFormat.DMY_DASH,
			isTimezone: true,
		});
	}, [arrivalTime, dateFns]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorArrivalDateCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutorArrivalDateCellContent;
